"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _pdfButton = _interopRequireDefault(require("../../../../core/pdf-button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getInitialState(competitionDivisions) {
  return {
    selectingOptions: false,
    generatingPDF: false,
    cardType: null,
    includeAllNonRanked: true,
    selectedDivisions: competitionDivisions.filter(d => !d.isRanking).map(d => d.id)
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("h5", null, "Do you want to include all paddlers in any of the following divisions?");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "This can be useful for non-ranking events where you may wish to provide temporary bibs, or for events where you know that the paddlers will not be ranked, eg Div 4.");
var _ref3 = /*#__PURE__*/_react.default.createElement("h5", null, "Do you want to include all paddlers that are not ranked?");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "This may include postal entries that were entered as non-ranked entries in to a ranked division whilst waiting for a bib allocation. Paddlers will be included on the list even if they are not in a selected division.");
var _ref5 = /*#__PURE__*/_react.default.createElement("h5", null, "You may also find it useful to download the RTC List as a pdf (available on the RTC tab).");
class CreateSignInSheet extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState(this.props.competition.competitionDivisions));
    _defineProperty(this, "_isSelected", id => {
      return this.state.selectedDivisions.indexOf(id) !== -1;
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(getInitialState(this.props.competition.competitionDivisions));
    });
    _defineProperty(this, "_onBegin", () => {
      this.setState({
        selectingOptions: true
      });
    });
    _defineProperty(this, "_onToggleDivision", (id, isSelected) => {
      this.setState({
        selectedDivisions: isSelected ? this.state.selectedDivisions.concat([id]) : this.state.selectedDivisions.filter(i => i !== id)
      });
    });
    _defineProperty(this, "_onToggleNonRanked", () => {
      this.setState({
        includeAllNonRanked: !this.state.includeAllNonRanked
      });
    });
    // this automatically closes the modal, but delays to allow some time for downloading
    // ideally want to know when generating is finished, but this is a compromise.
    _defineProperty(this, "_onGeneratingPDF", () => {
      this.setState({
        generatingPDF: true
      });
      setTimeout(() => {
        this._onCloseCancel();
      }, 2500);
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_pdfButton.default, {
      name: "sign-in-sheet",
      args: {
        competitionSlug: this.props.competition.competitionSlug,
        yearID: this.props.competition.yearID,
        includeAllNonRanked: this.state.includeAllNonRanked,
        selectedDivisions: this.state.selectedDivisions
      },
      type: "primary",
      disabled: this.state.generatingPDF,
      onClick: this._onGeneratingPDF
    }, "Download Sign-In Sheet"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Cancel"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        marginTop: 8
      },
      onClick: this._onBegin,
      type: "primary",
      block: true
    }, "Create Sign In Sheet"), !this.state.selectingOptions ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Create Sign In Sheet",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, _ref, _ref2, this.props.competition.competitionDivisions.map(division => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: division.id,
      type: "Checkbox",
      checked: this.state.selectedDivisions.indexOf(division.id) !== -1,
      onChange: this._onToggleDivision.bind(this, division.id),
      label: division.description
    })), _ref3, _ref4, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state.includeAllNonRanked,
      onChange: this._onToggleNonRanked,
      label: "Include All Non-Ranked Paddlers"
    }), _ref5));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CreateSignInSheet, "partialQueries", {
  Competition: {
    competitionSlug: true,
    yearID: true,
    competitionDivisions: {
      id: true,
      description: true,
      isRanking: true
    }
  }
});
var _default = exports.default = CreateSignInSheet;